import { render, staticRenderFns } from "./ThePaginator.vue?vue&type=template&id=f1d803f8"
import script from "./ThePaginator.vue?vue&type=script&lang=js"
export * from "./ThePaginator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports